<template>
  <span v-if="readOnly">{{ getLabel(modelValue) }}</span>
  <el-select
      v-else
      :model-value="modelValue"
      filterable
      clearable
      :placeholder="placeholder"
      :style="{width: getWidth}"
      @update:model-value="handleChange"
      @change="changeData"
  >
    <el-option
        v-for="item in dataList"
        :key="item[value]"
        :label="item[label]"
        :value="item[value]"
    />
  </el-select>
</template>

<script setup>
import {computed} from 'vue'

// eslint-disable-next-line no-undef
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  width: {
    type: String,
    default: '100%'
  },
  dataList: {
    type: Array,
    default: () => [],
    required: true
  },
  label: {
    type: String,
    default: '',
    required: true
  },
  value: {
    type: [String, Number],
    default: '',
    required: true
  }
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue', 'change'])

const getWidth = computed(() => {
  if (isNaN(props.width)) {
    return props.width
  } else {
    return props.width + 'px'
  }
})

const changeData = (data) => {
  for (let i = 0; i < props.dataList.length; i++) {
    if(data === props.dataList[i][props.value]){
      emit('change', props.dataList[i])
      return
    }
  }
  emit('change', {})
}

// 获取标签值
const getLabel = (value) => {
  const item = props.dataList.find(it => it[props.value] === value)
  changeData(value)
  return item ? item[props.label] : '暂无数据'
}

// 处理值变更
const handleChange = (value) => {
  emit('update:modelValue', value)
}

</script>